var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "博客、教程"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#博客、教程"
    }
  }, [_vm._v("#")]), _vm._v(" 博客、教程")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://ifeve.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("并发编程网"), _c('OutboundLink')], 1), _vm._v(" 让天下没有难学的技术")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://grokonez.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("grokonez"), _c('OutboundLink')], 1), _vm._v(" 各种软件开发教程网站，包括前端后端")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.sofastack.tech/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("sofastack"), _c('OutboundLink')], 1), _vm._v(" 蚂蚁金服技术官网")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://tech.meituan.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("meituan"), _c('OutboundLink')], 1), _vm._v(" 美团技术博客")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/ryanhanwu/How-To-Ask-Questions-The-Smart-Way",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("How-To-Ask-Questions-The-Smart-Way"), _c('OutboundLink')], 1), _vm._v(" 提问的智慧")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/gatieme/CodingInterviews",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("CodingInterviews"), _c('OutboundLink')], 1), _vm._v(" 剑指offer，计算机经典算法题")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/CyC2018/CS-Notes",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("CS-Notes"), _c('OutboundLink')], 1), _vm._v(" 计算机学习笔记")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/xingshaocheng/architect-awesome",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("architect-awesome"), _c('OutboundLink')], 1), _vm._v(" 后端架构师技术图谱")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/toutiaoio/awesome-architecture",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("awesome-architecture"), _c('OutboundLink')], 1), _vm._v(" 头条整理的架构师技术图谱")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/CyC2018/Interview-Notebook",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Interview-Notebook"), _c('OutboundLink')], 1), _vm._v(" 计算机学习笔记")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/leohxj/a-programmer-prepares",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("a-programmer-prepares"), _c('OutboundLink')], 1), _vm._v(" 程序员的自我修养")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/BruceDone/awesome-crawler",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("awesome-crawler"), _c('OutboundLink')], 1), _vm._v(" 爬虫技术资源汇总")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/open-power-workgroup/Hospital",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Hospital"), _c('OutboundLink')], 1), _vm._v(" OpenPower工作组收集汇总的莆田系医院开放数据")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/ruanyf/weekly",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("weekly"), _c('OutboundLink')], 1), _vm._v(" 阮一峰技术分享周刊")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://coolshell.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("酷壳"), _c('OutboundLink')], 1), _vm._v(" 耗子叔博客")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://thinkinjava.cn",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("莫那鲁道"), _c('OutboundLink')], 1), _vm._v(" 一个java开发者")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/rootsongjc/eng-practices",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("eng-practices"), _c('OutboundLink')], 1), _vm._v(" 谷歌工程实践（code review）文档")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "写作"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#写作"
    }
  }, [_vm._v("#")]), _vm._v(" 写作")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "ruanyf/document-style-guide",
      "desc": "中文技术文档的写作规范"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "gohugoio/hugo",
      "desc": "使用go语言编写的静态站点生成器"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "vuejs/vuepress",
      "desc": "基于vue开发的静态站点生成器"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "txd-team/docsite",
      "desc": "一款开源站点搭建工具，能够根据markdown文档快速搭建静态站点。"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "LearnShare/Learning-Markdown",
      "desc": "Markdown 入门参考"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "sparanoid/chinese-copywriting-guidelines",
      "desc": "中文文案排版指北"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "ksky521/nodeppt",
      "desc": "一个markdown转成ppt的工具，功能非常强大"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "ksky521/mpeditor",
      "desc": "微信markdown编辑器"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "pandao/editor.md",
      "desc": "一款开源的、可嵌入的 Markdown 在线编辑器"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "开发工具"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#开发工具"
    }
  }, [_vm._v("#")]), _vm._v(" 开发工具")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "judasn/IntelliJ-IDEA-Tutorial",
      "desc": "IntelliJ IDEA 简体中文专题教程"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "amix/vimrc",
      "desc": "vimrc 终极配置方案"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Aaaaaashu/Mac-dev-setup",
      "desc": "Mac 开发配置手册"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://vimawesome.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("vimawesome"), _c('OutboundLink')], 1), _vm._v(" vim 插件集合")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://vimjc.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("vimjc"), _c('OutboundLink')], 1), _vm._v(" 专注于Vim配置、插件、Vim命令和Vim教程（一个女生维护的）")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://coolshell.cn/articles/5426.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("coolshell"), _c('OutboundLink')], 1), _vm._v(" 简明 VIM 练级攻略")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "设计工具"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#设计工具"
    }
  }, [_vm._v("#")]), _vm._v(" 设计工具")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/LisaDziuba/Awesome-Design-Tools",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Awesome-Design-Tools"), _c('OutboundLink')], 1), _vm._v(" 各种设计工具汇总")]), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "bestony/logoly",
      "desc": "P 站 logo 生成器 😊"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "开源工具"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#开源工具"
    }
  }, [_vm._v("#")]), _vm._v(" 开源工具")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "oldj/SwitchHosts",
      "desc": "切换hosts文件的小程序"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "salomonelli/best-resume-ever",
      "desc": "个人简历生成工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "RedisInsight/RedisInsight",
      "desc": "redis 官方客户端"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "echo-layker/RedisDesktopManager-Mac",
      "desc": "第三方编译的redis-desktop-manager"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "ziahamza/webui-aria2",
      "desc": "aria2的web客户端"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://repo.or.cz/w/polysh.git",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("polysh"), _c('OutboundLink')], 1), _vm._v(" 可以同时连接多台服务器的ssh工具")]), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Hammerspoon/hammerspoon",
      "desc": "强大的macOS桌面自动化管理工具，可使用lua编写自定义功能"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "huashengdun/webssh",
      "desc": "一个基于web的ssh客户端"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jakubroztocil/httpie",
      "desc": "一个替代curl和wget的http客户端，json和语法高亮"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "ytdl-org/youtube-dl",
      "desc": "视频下载工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "rclone/rclone",
      "desc": "第三方网盘客户端，支持除了支持大部分网盘和文件共享协议"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://regex101.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("regex101"), _c('OutboundLink')], 1), _vm._v(" 在线正则匹配测试")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/apache/openwhisk-release",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("openwhisk-release"), _c('OutboundLink')], 1), _vm._v(" 开源协议源码监测工具")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "计算机基础"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#计算机基础"
    }
  }, [_vm._v("#")]), _vm._v(" 计算机基础")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "azl397985856/leetcode",
      "desc": "leetcode题解，非常多 star"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "justjavac/free-programming-books-zh_CN",
      "desc": "免费的计算机编程类中文书籍"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jobbole/awesome-programming-books",
      "desc": "经典编程书籍大全"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "数据库-缓存-nosql"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#数据库-缓存-nosql"
    }
  }, [_vm._v("#")]), _vm._v(" 数据库 & 缓存 & NoSql")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://mysql.taobao.org/monthly",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("mysql-monthly"), _c('OutboundLink')], 1), _vm._v(" 数据库内核月报")]), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jobbole/awesome-mysql-cn",
      "desc": "MySQL 资源大全中文版"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "apache/shardingsphere",
      "desc": "开源的分布式数据库增强计算引擎"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "alibaba/canal",
      "desc": "阿里开源的MySQL binlog消息订阅中间件"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "sripathikrishnan/redis-rdb-tools",
      "desc": "redis rdb 文件分析工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "alibaba/RedisShake",
      "desc": "一个用于在两个redis之间同步数据的工具，满足用户非常灵活的同步、迁移需求"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://redisdoc.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Redis Command Reference"), _c('OutboundLink')], 1), _vm._v(" 《Redis Command Reference》全文的中文翻译版")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://redisbook.readthedocs.io/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("readthedocs"), _c('OutboundLink')], 1), _vm._v(" Redis 设计与实现（第一版）")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "java"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#java"
    }
  }, [_vm._v("#")]), _vm._v(" java")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "akullpp/awesome-java",
      "desc": "java 资源汇总"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Snailclimb/awesome-java",
      "desc": "另一个 java 资源集合"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jobbole/awesome-java-cn",
      "desc": "Java资源大全中文版"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "giantray/stackoverflow-java-top-qa",
      "desc": "stackoverflow上Java相关回答整理翻译"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "alibaba/p3c",
      "desc": "阿里巴巴java开发手册"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "sjsdfg/effective-java-3rd-chinese",
      "desc": "effective-java第三版中文翻译"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "NotFound9/interviewGuide",
      "desc": "Java后端面试题精选"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "alibaba/arthas",
      "desc": "阿里开源Java诊断利器"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "btraceio/btrace",
      "desc": "于Java语言的一个安全的、可提供动态追踪服务的工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "doocs/advanced-java",
      "desc": "Java工程师进阶知识完全扫盲"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "cncounter/gc-handbook",
      "desc": "GC参考手册-Java版"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "vert-x3/vertx-awesome",
      "desc": "vertx资源汇总"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "VertxChina/vertx-translation-chinese",
      "desc": "vertx教程中文翻译"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "KotlinBy/awesome-kotlin",
      "desc": "kotlin资源汇总"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "zzhi/Java_Books",
      "desc": "Java 编程书籍分享"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "winterbe/java8-tutorial",
      "desc": "Java8教程"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "java8/Java8InAction",
      "desc": "java8 学习案例"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "iluwatar/java-design-patterns",
      "desc": "java设计模式代码实现"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "quanke/design-pattern-java",
      "desc": "设计模式 Java版本"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "code4craft/netty-learning",
      "desc": "Netty源码解析"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "waylau/netty-4-user-guide",
      "desc": "Netty 4.x 用户指南"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "waylau/essential-netty-in-action",
      "desc": "《Netty 实战(精髓)》"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "wuyinxian124/nettybook2",
      "desc": "李林峰老师编写的netty权威指南（第二版）对应的源码"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "YunaiV/SpringBoot-Labs",
      "desc": "基于spring-boot 2.x 的入门教程，涉及案例非常全面"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "dyc87112/SpringCloud-Learning",
      "desc": "Spring Cloud教程"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "eacdy/spring-cloud-study",
      "desc": "使用Spring Cloud与Docker实战微服务"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "qibaoguang/Spring-Boot-Reference-Guide",
      "desc": "Spring Boot参考指南"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "xkcoding/spring-boot-demo",
      "desc": "spring-boot 项目学习 demo，案例非常全"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Wechat-Group/WxJava",
      "desc": "微信Java开发工具包"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "seata/seata",
      "desc": "高性能、使用简单的分布式事务解决方案"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "google/guice",
      "desc": "Google 开发的一个轻量级ioc库"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "python"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#python"
    }
  }, [_vm._v("#")]), _vm._v(" python")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "vinta/awesome-python",
      "desc": "python 资源集合"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jobbole/awesome-python-cn",
      "desc": "python 资源集合中文版"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "yidao620c/python3-cookbook",
      "desc": "python3-cookbook的中文翻译"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.liaoxuefeng.com/wiki/1016959663602400",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("python tutorial"), _c('OutboundLink')], 1), _vm._v(" 廖雪峰的python教程")]), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "yorkoliu/pyauto",
      "desc": "python自动化运维：技术与最佳实践"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "pyenv/pyenv",
      "desc": "python的依赖管理工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "python-poetry/poetry",
      "desc": "另一个 python 依赖管理工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "marchtea/scrapy_doc_chs",
      "desc": "scrapy中文翻译文档"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.scrapyd.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("scrapyd.cn"), _c('OutboundLink')], 1), _vm._v(" scrapyd 中文网")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://dormousehole.readthedocs.io/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("readthedocs"), _c('OutboundLink')], 1), _vm._v(" flask中文文档")]), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Yixiaohan/show-me-the-code",
      "desc": "Python 练习册，每天一个小程序"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jackfrued/Python-100-Days",
      "desc": "Python - 100天从新手到大师"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "pandas-dev/pandas",
      "desc": "一个强大的分析结构化数据的工具集"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "teadocs/pandas-cn",
      "desc": "pandas中文翻译文档"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Kr1s77/awesome-python-login-model",
      "desc": "基于 selenium 的模拟登陆程序"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "go"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#go"
    }
  }, [_vm._v("#")]), _vm._v(" go")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "unknwon/the-way-to-go_ZH_CN",
      "desc": "《Go 入门指南》 - 《The Way to Go》的中文翻"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "astaxie/build-web-application-with-golang",
      "desc": "Go Web 编程"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "PuerkitoBio/goquery",
      "desc": "基于go实现，支持jquery语法的dom元素解析器"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "PuerkitoBio/goquery",
      "desc": "一个用Go编写的http web框架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "labstack/echo",
      "desc": "高性能、极简的Go web框架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jinzhu/gorm",
      "desc": "Golang ORM 框架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "sirupsen/logrus",
      "desc": "go的日志框架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "dgrijalva/jwt-go",
      "desc": "go实现的jwt"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "go-ini/ini",
      "desc": "go实现的ini配置文件解析"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "smallnest/go-rpc-programming-guide",
      "desc": "go-rpc-programming-guide"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "golang-china/gopl-zh",
      "desc": "Go语言圣经中文版"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Go-zh/tour",
      "desc": "Go 语言官方教程中文版"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "web-nodejs"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#web-nodejs"
    }
  }, [_vm._v("#")]), _vm._v(" web & nodejs")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jobbole/awesome-javascript-cn",
      "desc": "JavaScript 资源集合"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "sindresorhus/awesome-nodejs",
      "desc": "nodejs 资源汇总"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "goldbergyoni/nodebestpractices",
      "desc": "nodejs 最佳实践"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "haizlin/fe-interview",
      "desc": "前端面试题库，非常全"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "jobbole/awesome-css-cn",
      "desc": "CSS 资源大全中文版"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "vuejs/awesome-vue",
      "desc": "vue 资源大全"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "ruanyf/jstutorial",
      "desc": "阮一峰 - js教程"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "ruanyf/es6tutorial",
      "desc": "阮一峰 - ECMAScript 6入门"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "quasarframework/quasar",
      "desc": "基于 vue 构建的开源框架，用户可快速构建单页、移动端、服务端渲染应用"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "PanJiaChen/vue-element-admin",
      "desc": "基于vue-element的后台管理脚手架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "justjavac/awesome-wechat-weapp",
      "desc": "微信小程序开发资源汇总"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "eggjs/awesome-egg",
      "desc": "eggjs资源汇总"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "airyland/vux",
      "desc": "Vue & WeUI 实现的UI组件"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "alvarotrigo/fullPage.js",
      "desc": "全屏滚动插件"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "hakimel/reveal.js",
      "desc": "网页上制作PPT"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "GitSquared/edex-ui",
      "desc": "跨平台，科幻设计风格的终端模拟器，支持触摸屏"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "axios/axios",
      "desc": "http 请求库，支持 node 和 浏览器"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "nvm-sh/nvm",
      "desc": "node 版本管理器"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "nqdeng/7-days-nodejs",
      "desc": "七天学会NodeJS"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "alsotang/node-lessons",
      "desc": "Node.js 包教不包会"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "vercel/pkg",
      "desc": "node 可执行文件打包工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Unitech/pm2",
      "desc": "基于 nodejs 开发的进程管理器"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "koajs/koa",
      "desc": "nodejs 开发的 web 框架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "tj/commander.js",
      "desc": "nodejs 命令行开发工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "shelljs/shelljs",
      "desc": "跨平台命令工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "bda-research/node-crawler",
      "desc": "nodejs 爬虫框架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "octalmage/robotjs",
      "desc": "nodejs 按键精灵"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "typicode/lowdb",
      "desc": "nodejs 开发的本地数据库，支持在 nodejs、浏览器、electron 中运行"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "lua-openresty-nginx"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#lua-openresty-nginx"
    }
  }, [_vm._v("#")]), _vm._v(" lua & OpenResty & nginx")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "DocsHome/nginx-docs",
      "desc": "Nginx 中文文档"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "openresty/lua-nginx-module",
      "desc": "openresty 官方模块"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "LewisJEllis/awesome-lua",
      "desc": "lua资源集合"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "iresty/nginx-lua-module-zh-wiki",
      "desc": "nginx-lua-module 中文文档"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "bungle/awesome-resty",
      "desc": "openresty 资源集合"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "moonbingbing/openresty-best-practices",
      "desc": "openresty 最佳实践"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "sumory/openresty-china",
      "desc": "openresty中文社区"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "sumory/lor",
      "desc": "轻量级web开发框架lor"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "apache/incubator-apisix",
      "desc": "基于openresty的api网关"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "orlabs/orange",
      "desc": "基于openresty的api网关"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/orangle/study-resources/blob/master/OpenResty.md",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("study-resources"), _c('OutboundLink')], 1), _vm._v(" openresty 学习资源整理")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "消息中间件"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#消息中间件"
    }
  }, [_vm._v("#")]), _vm._v(" 消息中间件")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/rabbitmq/rabbitmq-tutorials",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("rabbitmq-tutorials"), _c('OutboundLink')], 1), _vm._v(" rabbitmq官方教程")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/apachecn/kafka-doc-zh",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("kafka-doc-zh"), _c('OutboundLink')], 1), _vm._v(" apachecn翻译的kafka中文文档")]), _vm._v(" "), _c('li')]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "elk"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#elk"
    }
  }, [_vm._v("#")]), _vm._v(" elk")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/apachecn/elasticsearch-doc-zh",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("elasticsearch-doc-zh"), _c('OutboundLink')], 1), _vm._v(" apachecn翻译的elasticsearch中文文档")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/apachecn/kibana-doc-zh",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("kibana-doc-zh"), _c('OutboundLink')], 1), _vm._v(" apachecn翻译的kibana中文文档")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "apm"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#apm"
    }
  }, [_vm._v("#")]), _vm._v(" APM")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/wg/wrk",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("wrk"), _c('OutboundLink')], 1), _vm._v(" 功能强大，使用简单的压力测试工具，支持 lua 脚本")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/opentracing",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("opentracing"), _c('OutboundLink')], 1), _vm._v(" 链路跟踪系统开源规范")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://wu-sheng.gitbooks.io/opentracing-io/content/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("opentracing-cn"), _c('OutboundLink')], 1), _vm._v(" OpenTracing 中文文档")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/openzipkin/zipkin",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("zipkin"), _c('OutboundLink')], 1), _vm._v(" Twitter开源的链路跟踪组件，支持opentracing规范")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/jaegertracing/jaeger/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Jaeger"), _c('OutboundLink')], 1), _vm._v(" Uber开源的链路跟踪组件，支持opentracing规范")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/elastic/apm-server",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("apm-server"), _c('OutboundLink')], 1), _vm._v(" elastic开源APM监控系统")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/dianping/cat",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("cat"), _c('OutboundLink')], 1), _vm._v(" 大众点评开源APM监控系统")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/apache/skywalking",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("skywalking"), _c('OutboundLink')], 1), _vm._v(" 国产开源APM监控系统，已加入apache项目")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/prometheus",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("prometheus"), _c('OutboundLink')], 1), _vm._v(" 一个开源的服务监控系统和时间序列数据库")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/dropwizard/metrics",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("metrics"), _c('OutboundLink')], 1), _vm._v(" 基于java平台的指标监控组件")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/micrometer-metrics/micrometer",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("micrometer"), _c('OutboundLink')], 1), _vm._v(" 另一个基于java平台的指标监控组件")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "操作系统"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#操作系统"
    }
  }, [_vm._v("#")]), _vm._v(" 操作系统")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/jaywcjlove/linux-command",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("linux-command"), _c('OutboundLink')], 1), _vm._v(" Linux命令大全搜索工具")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/me115/linuxtools_rst",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("linuxtools_rst"), _c('OutboundLink')], 1), _vm._v(" Linux工具快速教程")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/judasn/Linux-Tutorial",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Linux-Tutoria"), _c('OutboundLink')], 1), _vm._v(" Java程序员眼中的Linux")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/alim0x/Awesome-Linux-Software-zh_CN",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Awesome-Linux-Software"), _c('OutboundLink')], 1), _vm._v(" linux上超赞的应用，软件，工具以及其它资源的集中地")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "运维"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#运维"
    }
  }, [_vm._v("#")]), _vm._v(" 运维")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "KodeRover/Zadig",
      "desc": "开源云原生软件交付平台"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/jobbole/awesome-sysadmin-cn",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("awesome-sysadmin-cn"), _c('OutboundLink')], 1), _vm._v(" 系统管理员资源大全中文版")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/yeasy/docker_practice",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("docker_practice"), _c('OutboundLink')], 1), _vm._v(" Docker — 从入门到实践")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/h5bp/server-configs-nginx",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("server-configs-nginx"), _c('OutboundLink')], 1), _vm._v(" nginx配置案例")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/wangdoc/bash-tutorial",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("bash-tutorial"), _c('OutboundLink')], 1), _vm._v(" Bash 教程")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/tinyclub/open-shell-book",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("open-shell-book"), _c('OutboundLink')], 1), _vm._v(" Shell 编程范例")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/allinurl/goaccess",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("goaccess"), _c('OutboundLink')], 1), _vm._v(" 轻量级accesslog分析工具")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "flutter"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#flutter"
    }
  }, [_vm._v("#")]), _vm._v(" flutter")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/Solido/awesome-flutter",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("awesome-flutter"), _c('OutboundLink')], 1), _vm._v(" flutter 资源汇总")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/crazycodeboy/awesome-flutter-cn",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("awesome-flutter-cn"), _c('OutboundLink')], 1), _vm._v(" flutter 资源汇总中文版")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/alibaba/flutter-go",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("flutter-go"), _c('OutboundLink')], 1), _vm._v(" flutter 开发者帮助 APP")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "iot"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#iot"
    }
  }, [_vm._v("#")]), _vm._v(" IOT")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/micropython/micropython",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("micropython"), _c('OutboundLink')], 1), _vm._v(" 它基于ANSI C标准，语法跟Python 3基本一致，拥有自家的解析器、编译器、虚拟机和类库")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/DFRobot/uPyCraft",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("uPyCraft"), _c('OutboundLink')], 1), _vm._v(" MicroPython 开发 IED")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "架构"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#架构"
    }
  }, [_vm._v("#")]), _vm._v(" 架构")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://icyfenix.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("软件架构探索"), _c('OutboundLink')], 1), _vm._v(" 周志明老师的博客，谈软件架构")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "其他"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#其他"
    }
  }, [_vm._v("#")]), _vm._v(" 其他")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/pi-hole/pi-hole",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("pi-hole"), _c('OutboundLink')], 1), _vm._v(" 一个用来屏蔽广告的 dns 服务，支持自定义名单")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/homebridge/homebridge",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("homebridge"), _c('OutboundLink')], 1), _vm._v(" HomeKit 桥接服务，可以让其他不支持 HomeKit 的智能设备（如小米）接到 HomeKit")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };